





















import Debug from 'debug'
import short from 'short-uuid'
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { resolve } from '@/app/container';
import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';
import {
  SectionInteractionEvent,
  SectionInteractedEventName
} from '@/app/statistics/events/section-interaction-events';
import {
  IncludeComponentsService,
  IncludeComponentsServiceSymbol
} from '@/app/presenter/includer/include-components-service';
import { ACCORDION_TYPE } from '@/app/statistics/handlers/accordion-items-completion-handler';
import UiTaskHeaderComponent from '@/app/shared/components/ui/ui-task-header-component.vue';
import { ChildComponents } from "@/app/shared/utils/child-components";
import * as Api from "@/app/interaction/api";
import { AccordionState, AccordionContent } from "./accordion-interfaces";
import { TranslateResult } from 'vue-i18n';
import i18n from '@/plugins/i18n';
import HelpPopupComponent from "@/app/presenter/components/help-popup-component.vue";

const debug = Debug('accordion-component')

interface AccordionInnerState {
  [index: string]: {
    currentState: boolean;
    touched: boolean;
  }
}

@Component({
  components: {
    UiTaskHeaderComponent,
    HelpPopupComponent
  }
})
export default class AccordionComponent extends Vue
  implements Api.InteractiveComponent<AccordionState, AccordionContent> {

  @Prop({
    required: true
  })
  public meta: Api.InteractionComponentMeta;

  @Prop({
    required: true
  })
  public content: AccordionContent;

  @Prop({
    required: true
  })
  public state: AccordionState | null;

  private currentState: AccordionInnerState = this.initialState;

  private includeComponentsService: IncludeComponentsService
    = resolve<IncludeComponentsService>(IncludeComponentsServiceSymbol);

  private childComponents: ChildComponents= new ChildComponents('accordion-component')

  private get initialState(): AccordionInnerState {
    const state: AccordionInnerState = {};
    let index: number = 0;
    this.content.items.forEach((i) => {
      state[this.createCollapseId(index)] = {
        currentState: this.state?.states[index] || false,
        touched: this.state?.touched[index] || false,
      };
      index++;
    });

    return state;
  }

  private isTouched(index: number) {
    const collapseId = this.createCollapseId(index);
    const itemState = this.currentState[collapseId]

    return itemState && itemState.touched
  }

  private createCollapseId(index: number): string {
    return `collapse-${this.meta.id}-${index}`;
  }

  private async onCollapseInput(open: boolean, index: number) {
    const collapseId: string = this.createCollapseId(index);
    let changed: boolean = false;

    if (this.currentState[collapseId].currentState !== open) {
      changed = true;
    }

    this.currentState[collapseId].currentState = open;

    let progressChanged = false
    if (open) {
      // this.eventStream.dispatch({
      //   name: SectionInteractedEventName,
      //   payload: {
      //     interaction: {
      //       id: this.props.id,
      //       type: ACCORDION_TYPE,
      //       index
      //     }
      //   }
      // } as SectionInteractionEvent);
      // TODO: cancel
      const components = await this.includeComponentsService.includeComponents($(this.$el), { cancel: false });
      this.childComponents.register(components)

      if (!this.currentState[collapseId].touched) {
        this.currentState[collapseId].touched = true;
        progressChanged = true
      }
    }

    if (changed) {
      this.emitInteractionStateChanged();

      if (progressChanged) {
        this.emitInteractionResultChanged();
      }
    }
  }

  private beforeDestroy(): void {
    this.childComponents.destroy()
  }

  @Emit('interaction-result-changed')
  public emitInteractionResultChanged() {
    let touchedItems = 0;

    for (let i in this.currentState) {
      if (this.currentState[i].touched) {
        touchedItems ++;
      }
    }

    const progress = parseFloat((touchedItems / this.content.items.length).toFixed(2));

    const result: Api.Result = {
      progress,
      status: progress < 1 ? 'incomplete' : 'completed'
    }

    debug('emitInteractionResultChanged', result);

    return result
  }

  @Emit('interaction-state-changed')
  public emitInteractionStateChanged() {
    const state: AccordionState = {
      states: [],
      touched: [],
    };

    for (let i in this.currentState) {
      state.states.push(this.currentState[i].currentState);
      state.touched.push(this.currentState[i].touched);
    }

    debug('emitInteractionStateChanged', state);

    return state;
  }

  private t(key: string, params: any = {}): TranslateResult {
    return i18n.t(key, params);
  }
}
